module.exports = __webpack_public_path__ + "img/margot-maxi-vignette.ac9ea033.jpg";